import React, { useState } from 'react';
import { Cookie, X } from 'lucide-react';

const CookieConsent = ({ text }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 left-6 z-50 max-w-sm animate-in slide-in-from-bottom-4 duration-500">
       <div className="bg-slate-900/90 backdrop-blur-md border border-slate-700 p-5 rounded-2xl shadow-2xl text-white relative">
          <div className="flex items-start gap-4">
             <div className="p-2 bg-blue-600 rounded-lg shrink-0">
                <Cookie className="w-6 h-6 text-white" />
             </div>
             <div>
                <h4 className="font-bold text-sm mb-1">We use cookies</h4>
                <p className="text-xs text-slate-300 leading-relaxed mb-3">
                   {text || "This site uses cookies to ensure you get the best experience on our security grid."}
                </p>
                <div className="flex gap-3">
                   <button onClick={() => setIsVisible(false)} className="bg-white text-slate-900 px-4 py-1.5 rounded-lg text-xs font-bold hover:bg-slate-200 transition-colors">
                      Accept
                   </button>
                   <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-white text-xs font-medium">
                      Decline
                   </button>
                </div>
             </div>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-500 hover:text-white">
             <X className="w-4 h-4" />
          </button>
       </div>
    </div>
  );
};

export default CookieConsent;